/* eslint-disable react/destructuring-assignment */
import React, { FC } from 'react';
import { ChargeFormEntry } from '../../types';
import { MobileChargesCardRow } from './MobileChargesCardRow';
import { MobileChargeDocumentCard } from './MobileChargeDocumentCard';
import { ListingEntry } from 'graphql/listings/queries';

interface Props {
  charge: ChargeFormEntry;
  index: number;
  currentLetter?: string;
  textPredectiveCharges: ListingEntry[];
  hideTax: boolean;
  onDeleteCharge: (rowIndex: number) => void;
  onEditCharge: (charge: ChargeFormEntry, rowIndex: number) => void;
  onEditSplitAmount: (charge: ChargeFormEntry, kind: 'Payee' | 'Payer' | 'Tax') => void;
  isPartiesOpen: boolean;
  onToggleParties: () => void;
  onChargeAmountChange: (newAmount: number | null) => void;
  onChargePaidByAmountChange: () => void;
}

export const MobileChargesCard: FC<Props> = ({
  charge,
  index,
  currentLetter,
  textPredectiveCharges,
  hideTax,
  onDeleteCharge,
  onEditCharge,
  onEditSplitAmount,
  isPartiesOpen,
  onToggleParties,
  onChargeAmountChange,
  onChargePaidByAmountChange,
}) => {
  const chargeIsDocument = charge.code === 'document';

  if (chargeIsDocument) {
    return (
      <MobileChargeDocumentCard
        charge={charge}
        index={index}
        currentLetter={currentLetter}
        textPredectiveCharges={textPredectiveCharges}
        onDelete={onDeleteCharge}
        onEdit={onEditCharge}
        onEditSplitAmount={onEditSplitAmount}
        isPartiesOpen={isPartiesOpen}
        onToggleParties={onToggleParties}
        onChargeAmountChange={onChargeAmountChange}
        onChargePaidByAmountChange={onChargePaidByAmountChange}
      />
    );
  }

  return (
    <MobileChargesCardRow
      charge={charge}
      index={index}
      textPredectiveCharges={textPredectiveCharges}
      hideTax={hideTax}
      onDeleteCharge={onDeleteCharge}
      onEditSplitAmount={onEditSplitAmount}
      onChargeAmountChange={onChargeAmountChange}
    />
  );
};
